import ButtonGroup from 'antd/lib/button/button-group'
import { DatePickerComponent, ListComponent } from 'containers/backend/common/component/Index'
import Wrapper from 'containers/backend/common/component/Wrapper'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import {useGetListBundleReport} from 'hooks/report/useGetListBundleReport'
import { Button } from 'antd'
import DEFINE, { CHANNELS, DATE_TIME_FORMAT, ORDER, PATHS, SALE_CHANNELS, typeReportBundle, typeReportSku } from 'constants/Define'
import * as Func from 'helpers/functions';
import { Link } from 'react-router-dom'
import Span from 'containers/backend/common/component/Span'
import * as HMS from "containers/backend/common/component/Index";
import * as ANT from 'antd';
import FontIcon, { SolidIcons } from 'containers/backend/common/component/FontIcon'
import { find } from 'lodash'
import { getLocaleFullName, parseListRequestParams } from 'utils/commonUtils'
import EllipsisText from 'containers/backend/common/component/EllipsisText'
import AntSelect, { AntOption } from 'containers/backend/common/component/AntSelect'
import { generateStringId } from 'utils/orders'


const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}

const ReportListCols = [
    'id','orderCode', 'orderId', 'paymentType', 'paymentStatus', 'orderStatus', 'saleChannel',
    'channel', 'orderItemType', 'createdDate', 'fullname', 'email', 'phoneNumber', 'fullnameCustomer', 'emailCustomer',
    'phoneNumberCustomer', 'memberShipCode', 'couponCode', 'couponValue', 'subTotal', 'surcharge', 'surchargeDetail', 
    'totalAmount', 'note', 'startPoint', 'endPoint', 'airlineCode', 'pnr', 'checkInDate', 'checkOutDate', 'hotelName',
    'roomType', 'quickTaskStatus', 'ratePlanName', 'priceRoom', 'markUpPriceRoom', 'ticketPrice', 'totalMarkUpTicket', 'salePrice'
]

const removeCols = [
    'id',
]

const BundleReportList = (props) => {
    //! Props
    const {t, match, permissionActions, bundleReportList, isLoading,
            query, setQuery, onChangeTable, onSelectTypeReport, exportBundleExcel, bundleReportState} = props;
            
    //! State
    const titleItemTable = Func.getTitleTable(ReportListCols, [], removeCols);
    let componentTable = {
        orderCode: {
            key: 'orderCode',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => 
                <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                    <Span>{text}</Span>
                </Link>
        },
        orderId: {
            key: 'orderId',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => 
                <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                    <Span>{text}</Span>
                </Link>
        },
        paymentType: {
            key: 'paymentType',
            render: (paymentType, data) => <Fragment>
                {paymentType && <div className="g-mt-5">
                    <HMS.StatusComponent color={'gray'}
                        label={t(`item.order.paymentTypes.${data.paymentType}`)} />
                </div>
                }
            </Fragment>,
            filters: [
                { value: 'vnpay', text: t(`item.order.paymentTypes.vnpay`) },
                { value: 'onepay', text: t(`item.order.paymentTypes.onepay`) },
                // { value: 'zalo', text: t(`item.order.paymentTypes.zalo`) },
                // { value: 'shopeepay', text: t(`item.order.paymentTypes.shopeepay`) },
                { value: 'paylater', text: t(`item.order.paymentTypes.paylater`) },
                { value: 'cash', text: t(`item.order.paymentTypes.cash`) },
                { value: 'transfer', text: t(`item.order.paymentTypes.transfer`) },
                { value: 'qrcode', text: t(`item.order.paymentTypes.qrcode`) },
                { value: 'other', text: t(`item.order.paymentTypes.other`) },
                { value: 'momo', text: t(`item.order.paymentTypes.momo`) },
                { value: 'twoc2p', text: t(`item.order.paymentTypes.twoc2p`) },
            ],
            filterMultiple: false,
        },
        paymentStatus: {
            key: 'paymentStatus',
            render: (paymentStatus, data) => <Fragment>
                        <HMS.StatusComponent color={paymentStatus === 2 ? 'green' : (paymentStatus === 4 ? 'blue' : 'red')}
                            label={t(`item.order.paymentStatusEnum.${paymentStatus}`)} />
                        <br />
                    </Fragment>,
            filters: [
                { value: 1, text: t(`item.order.paymentStatusEnum.1`) },
                { value: 2, text: t(`item.order.paymentStatusEnum.2`) },
                { value: 4, text: t(`item.order.paymentStatusEnum.4`) },
                { value: 5, text: t(`item.order.paymentStatusEnum.5`) },
                
            ],
            filterMultiple: false,
        },
        orderStatus: {
            key: 'orderStatus',
            render: (status, data) => <Fragment>
            <HMS.StatusComponent color={data.orderStatus === 2 ? 'green' : (data.orderStatus === 4 ? 'blue' : 'red')}
                    label={t(`item.order.orderStatus.${data.orderStatus}`)} />
            </Fragment>,
            filters: [
                { value: 1, text: t(`item.order.orderStatus.1`) },
                { value: 2, text: t(`item.order.orderStatus.2`) },
                // { value: 3, text: this.props.t(`item.order.orderStatus.3`) },
                // { value: 4, text: this.props.t(`item.order.orderStatus.4`) },
                { value: 5, text: t(`item.order.orderStatus.5`) },
                { value: 6, text: t(`item.order.orderStatus.6`) },
                { value: 7, text: t(`item.order.orderStatus.7`) },
                { value: 8, text: t(`item.order.orderStatus.8`) },
                { value: 9, text: t(`item.order.orderStatus.9`) },
            ],
            filterMultiple: true,
        },
        saleChannel: {
            key: 'saleChannel',
            render: (value, data) => value && t(`item.order.saleChannels.${value}`),
            filters: Object.keys(SALE_CHANNELS).map(item => ({ value: SALE_CHANNELS[item], text: t(`item.order.saleChannels.${SALE_CHANNELS[item]}`) })),
            filterMultiple: false,
        },
        channel: {
            key: 'channels',
            render: (value, data) => value && t(`item.order.channels.${value}`),
            filters: Object.keys(CHANNELS).map(item => (
                { value: CHANNELS[item], text: t(`item.order.channels.${CHANNELS[item]}`) 
            })),
            filterMultiple: true,
        },
        orderItemType: {
            key: 'itemTypes',
            width: 100,
            render: (type) => {
                const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === type)
                return typeKey && <ANT.Tooltip key={typeKey} title={t(`item.order.orderTypes.${ORDER.TYPES[typeKey].key}`)}><Span className="ml-2">
                    <FontIcon key={type} color={ORDER.TYPES[typeKey].color} icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="lg" />
                </Span></ANT.Tooltip>
            },
            filters: [
                { value: ORDER.TYPES['VOUCHER'].id, text: t(`item.order.orderTypes.${ORDER.TYPES['VOUCHER'].key}`) },
                { value: ORDER.TYPES['TOUR'].id, text: t(`item.order.orderTypes.${ORDER.TYPES['TOUR'].key}`) },
                { value: ORDER.TYPES['VINWONDER'].id, text: t(`item.order.orderTypes.${ORDER.TYPES['VINWONDER'].key}`) },
                { value: ORDER.TYPES['FLIGHT'].id, text: t(`item.order.orderTypes.${ORDER.TYPES['FLIGHT'].key}`) },
                { value: ORDER.TYPES['HOTEL'].id, text: t(`item.order.orderTypes.${ORDER.TYPES['HOTEL'].key}`) }
            ],
            filterMultiple: true,
        },
        createdDate: {
            render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
        },
        fullname: {
            key: 'fullname',
            render: (text, data) => data.fullname || getLocaleFullName(data.firstname, data.lastname),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => 
                <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                    <Span>{text}</Span>
                </Link>
        },
        email: {
            key: 'email',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => 
                <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                    <Span>{text}</Span>
                </Link>
        },
        phoneNumber: {
            key: 'phoneNumber'
        },
        fullnameCustomer: {
            key: 'fullnameCustomer'
        },
        emailCustomer: {
            key: 'emailCustomer'
        },
        phoneNumberCustomer: {
            key: 'phoneNumberCustomer'
        },
        memberShipCode: {
            key: 'memberShipCode'
        },
        couponCode: {
            key: 'couponCode',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => text
        },
        couponValue: {
            key: 'couponValue',
            align: "right",
            render: (couponValue) => Func.formatMoney(couponValue)
        },
        subTotal: {
            key: 'subTotal',
            align: "right",
            render: (subTotal) => Func.formatMoney(subTotal)
        },
        surcharge: {
            key: 'surcharge',
            align: "center",
            render: (surcharge, row, index) => {
                const obj = {
                    children:  Func.formatMoney(surcharge),
                    props: {},
                }
                if(index > 0 && (row?.orderId === row?.dataList[index-1]?.orderId)){
                    obj.children = ""
                }

                return obj
            }
        },
        surchargeDetail: {
            key:'surchargeDetail',
            render: (surchargeDetail, row, index) => {
                const obj = {
                    children: surchargeDetail,
                    props: {},
                }
                if(index > 0 && (row?.orderId === row?.dataList[index-1]?.orderId)){
                    obj.children = ""
                }

                return obj
            }
        },
        totalAmount: {
            key: 'totalAmount',
            align: "right",
            render: (amount) => Func.formatMoney(amount)
        },
        note: {
            key: 'note',
            width: 300,
            render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
        },
        startPoint: {
            key: 'startPoint'
        },
        endPoint: {
            key: 'endPoint'
        },
        airlineCode: {
            key: 'airlineCode'
        },
        pnr: {
            key: 'pnr'
        },
        checkInDate: {
            key: 'checkInDate',
            render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
        },
        checkOutDate: {
            key: 'checkOutDate',
            render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
        },
        hotelName: {
            key: 'hotelName',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => text
        },
        roomType: {
            key: 'roomType'
        },
        quickTaskStatus: {
            key: 'quickTaskStatus'
        },
        ratePlanName: {
            key: 'ratePlanName',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) => text
        },
        priceRoom: {
            key: 'priceRoom',
            align: 'center',
            render: (priceRoom) => Func.formatMoney(priceRoom)
        },
        markUpPriceRoom: {
            key: 'markUpPriceRoom',
            align: 'center',
            render: (markUpPriceRoom) => Func.formatMoney(markUpPriceRoom)
        },
        ticketPrice: {
            key: 'ticketPrice',
            align: 'right',
            render: (ticketPrice) => Func.formatMoney(ticketPrice)
        },
        totalMarkUpTicket: {
            key: 'totalMarkUpTicket',
            align: 'right',
            render: (totalMarkUpTicket) => Func.formatMoney(totalMarkUpTicket)
        },
        salePrice: {
            key: 'salePrice',
            align: "right",
            render: (salePrice) => Func.formatMoney(salePrice)
        }

    }

    //! Function
    const onSelectDateRange = (data) => {
        const newFilters = {...query};
        newFilters.pageIndex = 1;
        newFilters.startDate = data?.fullValue[0];
        newFilters.endDate = data?.fullValue[1];
        if(newFilters?.endDate?.diff(newFilters?.startDate, 'days') >= 30) {
            newFilters.endDate = moment(newFilters.startDate).add(29, 'days')
        }
        setQuery({...newFilters})
    }

    const onExportExcel = (isExcludeUserInfo = false) => {
        const filters = query;
        filters.pageIndex = undefined;
        filters.pageSize = undefined;
        filters.isExcludeUserInfo = isExcludeUserInfo;
        return exportBundleExcel(parseListRequestParams({...query, ...filters}))
    }   

    //! Effect
    //! Render
  return (
    <Wrapper className="col-md-12 p-0 mt-3 report-list bundle-report">
        <Wrapper className="col-md-12 row m-0 p-0 report-list-title align-items-end">
            <h3 className={`col-md-2 ml-0 p-0`}>{""}</h3>
            <Wrapper className={`col-md-5 m-0 p-0 pr-2 button-section`}>
                {permissionActions && permissionActions.allowExportFileExcel &&
                    <Button type="primary" onClick={() => onExportExcel(false)}
                        icon="download" loading={bundleReportState?.isDownloading}
                        disabled={!(bundleReportList && bundleReportList.length)}
                        className="mr-2">{t(`item.report.exportExcel`)}</Button>
                }
            </Wrapper>
            <Wrapper className={`align-items-end col-md-4 d-flex flex-column m-0 p-0 pr-2`}>
                <ButtonGroup>
                    <Button type="dashed" onClick={() => onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                    <Button type="dashed" onClick={() => onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                    <Button type="dashed" onClick={() => onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                </ButtonGroup>
                <DatePickerComponent 
                    className={`form-control applyDates w100-percent mt-1`}
                    hmsComponent={`RangePicker`} 
                    format={DATE_TIME_FORMAT.SHORT_DATE}
                    style={{ padding: 0, border: 0 }}
                    onChange={onSelectDateRange}
                    name={`applyDates`}
                    placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                    value={[query.startDate, query.endDate]}
                    // onCalendarChange={val => this.setState({...this.state, applyDateRanges: val })}
                    // disabledDate={disabledDate}
                    // onOpenChange={onOpenChange}
                />
            </Wrapper>
            <Wrapper className={`align-items-end col-md-1 d-flex flex-column m-0 p-0`}>
                <AntSelect
                    showArrow
                    // mode="multiple"
                    // suffixIcon={<Icon type="search" />}
                    // filterOption={this.selectFilterSearch}
                    value={query.filterType}
                    name={`filterType`}
                    onChange={onSelectTypeReport}
                    style={{width: '100%'}}
                >
                    { (typeReportBundle || []).map(el => (
                        <AntOption key={ el.text } value={ el.value }>
                            { el.text }
                        </AntOption>
                    )) }
                </AntSelect>
            </Wrapper>
        </Wrapper>
        <Wrapper className={`mt-2`}>
            <ListComponent
                tableKey="bundle-report"
                scroll={{ x: 5500 }}
                classParent="m-0 p-0 bundle-report-list"
                marginTop={'0'} marginBottom={'0'}
                loading={{ spinning: isLoading, size: 'large' }}
                rowKey={(record, k) => generateStringId(10)}
                dataSource={bundleReportList}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'bundleReport'
                })}
                pagination={{ total: query.totalCount, totalPage: query.totalPage, current: query.pageIndex, pageSize: query.pageSize }}
                onChange={onChangeTable}
            />
        </Wrapper>
    </Wrapper>
  )
}

export default BundleReportList